import React from 'react';
import { useNavigate } from 'react-router-dom';
import './CategoryCompletionScreen.css';
import { FaTrophy, FaStar, FaMedal } from 'react-icons/fa';

interface CategoryCompletionScreenProps {
  categoryName: string;
}

const CategoryCompletionScreen: React.FC<CategoryCompletionScreenProps> = ({ categoryName }) => {
  const navigate = useNavigate();

  return (
    <div className="category-completion">
      <h1 className="completion-title">Category Complete!</h1>
      <h2 className="completion-subtitle">{categoryName} Mastery Achieved</h2>
      <div className="action-buttons">
        <button 
          className="action-button primary-button"
          onClick={() => navigate('/welcome')}
        >
          Play another category
        </button>
        <button 
          className="action-button secondary-button"
          onClick={() => navigate('/leaderboard')}
        >
          View Leaderboard
        </button>
      </div>
    </div>
  );
};

export default CategoryCompletionScreen; 